import { FC, ReactNode, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import { ModelCarousel } from 'components/common/ModelCarousel';
import { clientApiGet } from 'lib/api_helper';
import { ListingStat, Model, SimilarBrandModels } from 'types';

const showHitsInCarousel = (availableModels: Model[], unavailableModels: Model[], modelId: number) => {
  let hits = [...availableModels];

  if (hits.length < 12) {
    hits = hits.concat(unavailableModels);
  }

  return hits.filter(hit => !!hit && hit.id !== modelId); // remove current model from carousel
};

type SimilarAppearanceModelsProps = {
  formatTitle?: (title: string) => ReactNode;
  model: Model;
  similarResults?: SimilarBrandModels;
};
export const SimilarAppearanceModels: FC<SimilarAppearanceModelsProps> = ({
  model,
  similarResults,
  formatTitle = title => title
}) => {
  const [similarAppearanceHits, setSimilarAppearanceHits] = useState<Model[]>([]);

  useEffect(() => {
    const getSimilarModels = async () => {
      if (!similarResults || isEmpty(similarResults)) {
        return;
      }

      const appearanceAvailableHits =
        similarResults?.appearanceAvailable?.hits?.filter(Boolean).map(modelItem => modelItem.object) || [];
      const appearanceUnavailableHits =
        similarResults?.appearanceUnavailable?.hits?.filter(Boolean).map(modelItem => modelItem.object) || [];

      const similarAppearance = showHitsInCarousel(appearanceAvailableHits, appearanceUnavailableHits, model.id);
      const modelIds = similarAppearance.map(a => a.id);

      const listingStats: ListingStat[] = await clientApiGet(`/api/batchListings/stats?modelIds=${modelIds}`);

      if (listingStats) {
        // add lowest price of listing(s) + count (if applicable) to models

        for (const hit of similarAppearance) {
          const id = hit.id;

          hit.lowestPrice = listingStats[id]?.minPrice;
          hit.count = listingStats[id]?.count ?? 0;
        }
        setSimilarAppearanceHits(similarAppearance);
      }
    };

    getSimilarModels();
  }, [similarResults, setSimilarAppearanceHits, model.id]);

  return (
    <>
      {similarAppearanceHits.length > 0 && (
        <ModelCarousel
          title={formatTitle(model.caseMaterials[0].name + ' ' + model.dialColor.name.toLowerCase() + ' dials')}
          items={similarAppearanceHits}
        />
      )}
    </>
  );
};
